module.exports = __webpack_public_path__ + "young.png?e130560990d389d8ce27b2be9268e17b";


//////////////////
// WEBPACK FOOTER
// ./src/assets/art/young.png
// module id = 119
// module chunks = 0